import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import SchoolHandover from "./routes/SchoolHandover";
import ContractTraking from "./routes/ContractTracking";
import ProductRequest from "./routes/ProductRequest";
import NpsSurveySetup from "./routes/NpsSurveySetup";
import LRTDashboard from "./routes/LRTDashboard";

export default store => ({
  path: "internalTools",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "administrator-tooling" */ "./InternalTools"
        ),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    SchoolHandover(store),
    ContractTraking(store),
    ProductRequest(store),
    NpsSurveySetup(store),
    LRTDashboard(store),
  ],
});
